$(function(){
  $('a[href^="#"]').not('.popup-modal').on('click', function(e){
    var href = $(this).attr("href");

    // 念のため：hrefが空/無い場合は何もしない
    if (!href) return;

    // "#" 単体は html へ
    var target = $(href === "#" ? 'html' : href);

    // 念のため：ターゲットが存在しない場合は何もしない
    if (!target.length) return;

    e.preventDefault();

    var speed = 400;
    var position = target.offset().top;
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
  });
});